// @flow
import type { ShiftPatternsState } from "./types";

export const onGetClientShiftPatternsSuccess = (state: ShiftPatternsState) => ({
  payload,
}: any) => ({
  ...state,
  error: null,
  list: payload,
});

export const onGetClientShiftPatternsError = (state: ShiftPatternsState) => ({ payload }: any) => ({
  ...state,
  error: payload,
});
